import React from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import ReactLoading from "react-loading";
import withPermissions from "../../components/WithPermissions";
import ParasutEinboxTable from "../../components/Tables/ParasutEinboxTable";

class EInvoiceInbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      isLoad:false,

    }
  }
  render() {

    return (
      <div
        style={{ flex: 1 }}
        onClick={() => {
          document.body.classList.remove("offcanvas-active");
        }}
      >
        <div>
          <div className="page-loader-wrapper" style={{display: this.state.isLoad ? 'block' : 'none'}}>
            <div className="loader" style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <div className="m-t-30">
                <img src={require('../../assets/images/logo-white.png')} width="150" alt="Lucid"/>
              </div>
              <p>Yükleniyor</p>
              <ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff"/>
            </div>
          </div>
          <div className="container-fluid">
            <PageHeader
                HeaderText="Fatura Gelen Kutusu"
                Breadcrumb={[
                  {name: "Faturalar", navigate: ""},
                  {name: "Fatura Gelen Kutusu", navigate: ""},
                ]}
            />
            <div className="row clearfix">
              <div className="col-lg-12">
                <div className="card">
                  <div className="body">
                    <div className="row clearfix">
                      <div className="col-lg-12 col-md-12">
                          <ParasutEinboxTable></ParasutEinboxTable>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({analyticalReducer}) => ({

});

export default withPermissions(withRouter(connect(mapStateToProps, {
})(EInvoiceInbox)));
